import userAbi from 'abis/user_stats.json'
import BigNumber from 'bignumber.js'
import { BANK_ADDRESS } from 'constants/addresses'
import { SWC } from 'constants/tokens'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import useRefresh from 'hooks/useRefresh'
import { useCallback, useEffect, useState } from 'react'
import { BIG_ZERO } from 'utils/bigNumber'
// import { BIG_ZERO } from 'utils/bigNumber'
import Multicall from 'utils/multicall'
import { isChainAllowed } from 'utils/switchChain'

import { UserDetails } from '../types/user'

const usePlayerData = (): UserDetails => {
  const { slowRefresh } = useRefresh()
  const { account, chainId, connector } = useActiveWeb3React()
  const [state, setState] = useState({
    swcBalance: BIG_ZERO,
    chipsBalance: BIG_ZERO,
    trBalance: BIG_ZERO,
  })

  const chainAllowed = chainId && isChainAllowed(connector, chainId)

  const swcAddress = SWC[chainAllowed ? chainId : 137].address
  const bankAddress = BANK_ADDRESS[chainAllowed ? chainId : 137]
  /* const rewardsAddress = PLAY_REWARDS_ADDRESS[chainAllowed ? chainId : 137] */

  const fetchData = useCallback(async () => {
    const UserCalls = [
      { address: swcAddress, name: 'balanceOf', params: [account] },
      { address: bankAddress, name: 'playerCredits', params: [account] },
      /* { address: rewardsAddress, name: 'getRewardTokenBalance', params: [account] }, */
    ]

    const [balanceOf, playerCredits /* , getRewardTokenBalance */] = await Multicall(
      chainAllowed ? chainId : 137,
      userAbi,
      UserCalls
    )

    setState((prev) => ({
      ...prev,
      swcBalance: new BigNumber(balanceOf[0].toString() ?? '0'),
      chipsBalance: new BigNumber(playerCredits[0].toString() ?? '0'),
      /*  trBalance: new BigNumber(getRewardTokenBalance[0].toString() ?? '0'), */
    }))
  }, [account, bankAddress, chainAllowed, chainId, swcAddress])

  useEffect(() => {
    if (account) {
      fetchData()
    }
  }, [account, fetchData, slowRefresh])

  return { ...state, fetchData }
}

export default usePlayerData
